import { useCallback, useState } from "react";
import PropTypes from "prop-types";

import { FormattedMessage } from "react-intl";

import AmountContainer from "app/pages/.shared/AmountContainer.jsx";
import Badge from "app/pages/.shared/Badge.jsx";
import MoreDetails from "app/pages/.shared/MoreDetails.jsx";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";
import RadioFormik from "app/pages/.shared/form/RadioFormik";

import { quotationTransferShape } from "app/utils/propTypes";

import "./QuotationTransferItem.scss";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";

const IMAGE_SIZES = {
	small: { width: 130 },
	medium: { width: 130 },
	large: { width: 130 },
	xlarge: { width: 130 },
};

const QuotationTransferItem = ({
	transfer,
	onChange,
	defaultToNoTransfer,
	isFirstTransferIncluded,
	indexInArray,
}) => {
	const { code, quantity, description, photo = {} } = transfer;
	const [showDetails, toggleDetails] = useState(false);
	const [firstSentence, ...remainingDescription] = description ? description.split(".") : "";
	const showDetailsLabel = showDetails ? (
		<FormattedMessage id="product.page.less.details" />
	) : (
		<FormattedMessage id="product.page.more.details" />
	);
	const memoizedToggleDetails = useCallback(
		event => {
			event.preventDefault();
			toggleDetails(!showDetails);
		},
		[showDetails]
	);
	let priceNode = null;

	if (transfer.included === true) {
		priceNode = (
			<Badge>
				<FormattedMessage id="general.included" />
			</Badge>
		);
	} else if (isFirstTransferIncluded || indexInArray !== 0) {
		let price = isFirstTransferIncluded ? transfer.upgradePrice : transfer.price;
		priceNode = (
			<div className="quotation-transfer-item__upgrade-price">
				<AmountContainer amount={price} prefix={<AmountSign sign="+" />} />
			</div>
		);
	}

	// @todo rendre le composant MoreDetails stateless ?

	return (
		<div className="quotation-transfer-item">
			<RadioFormik
				id={code}
				showIcon={true}
				name="transfer"
				toggle={onChange.bind(null, transfer)}
				value={code}
				data-testid={code}
				body={
					description && (
						<div className="quotation-transfer-item__body">
							{/*
					@todo: Refacto les endroits où l'on utilise MoreDetails. La refacto consiste à utiliser les props afin de rendre le bouton + / - de détails et d'éviter
					d'implémenter cette logique (en double) en dehors du composant MoreDetails

					Composants concernés : QuotationRoom, tout les composants utilisant MoreDetails et implémentant le bouton toggle à la place de moreDetails
				*/}
							<div
								className="quotation-rooms__details-button"
								onClick={memoizedToggleDetails}
							>
								{showDetailsLabel}
							</div>
							<div className="quotation-transfer-item__short-description">
								{photo.url && photo.thumbnail && (
									<div className="quotation-transfer-item__img">
										<ProgressiveImg
											sizes={IMAGE_SIZES}
											src={photo.url}
											thumbnail={photo.thumbnail}
										/>
									</div>
								)}
								<p>{firstSentence}.</p>
							</div>
							<MoreDetails headerPosition="top" expanded={showDetails}>
								<p>{remainingDescription.join(".")}</p>
							</MoreDetails>
						</div>
					)
				}
			>
				<div className="quotation-transfer-item__content">
					<div className="quotation-transfer-item__label">
						{defaultToNoTransfer ? (
							<FormattedMessage id="quotation.transfer.no.transfer" />
						) : (
							<div>
								<span className="quotation-transfer-item__quantity">
									{`${quantity} x `}
								</span>
								{transfer.vehicule}
							</div>
						)}
					</div>
					{priceNode}
				</div>
			</RadioFormik>
		</div>
	);
};

QuotationTransferItem.propTypes = {
	indexInArray: PropTypes.number,
	transfer: quotationTransferShape.isRequired,
	onChange: PropTypes.func.isRequired,
	defaultToNoTransfer: PropTypes.bool,
	isFirstTransferIncluded: PropTypes.bool,
};

export default QuotationTransferItem;
